import React, { useEffect } from "react";
import "./SuccesfullModal.css";
import { Modal } from "react-bootstrap";
import Successfull_Lottie from "../SuccesfullModal/Successfull_Lottie/Successfull_Lottie";

const SuccesfullModal = (props) => {
  const { message, onHide } = props; // Add onHide prop to call when the modal closes

  useEffect(() => {
    // Set a timeout to close the modal after 3 seconds
    const timer = setTimeout(() => {
      if (onHide) {
        onHide(); // Call the onHide function to close the modal
      }
    }, 3000); // 3000 milliseconds = 3 seconds

    return () => clearTimeout(timer); // Cleanup the timeout on unmount
  }, [onHide]);

  return (
    <div className="Successfull_Modal_sec">
      <Modal
        className="Successfull_Modal"
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="lottie-holder">
            <Successfull_Lottie />
          </div>
          <p>{message}</p>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SuccesfullModal;
